module.exports = __webpack_public_path__ + "static/img/hdq0417.828a435.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hdq0417.jpg
// module id = tiC+
// module chunks = 0